import React from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-24">
        <article className="max-w-4xl mx-auto prose prose-lg">
          <header>
            <h1 className="text-4xl font-bold text-foreground mb-4">Terms & Conditions</h1>
            <p className="text-muted-foreground mb-8">
              <strong>Effective Date:</strong> September 22, 2025
            </p>
          </header>

          <section className="mb-8">
            <p className="text-foreground leading-relaxed">
              These Terms & Conditions ("Terms") govern your use of CountedCare Inc.'s services ("Services"). By creating an account or using the Services, you agree to these Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">1. Use of Services</h2>
            <ul className="space-y-2 text-foreground">
              <li>CountedCare provides tools for expense tracking, receipt uploads, Plaid account connections, and AI-powered financial insights.</li>
              <li>We are <strong>not a tax advisor, accountant, or legal advisor</strong>. Information is for educational purposes only. Consult professionals for advice.</li>
              <li>Eligibility for tax deductions or programs is <strong>not guaranteed</strong>.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">2. Subscriptions & Payments</h2>
            <ul className="space-y-2 text-foreground">
              <li>Stripe processes subscription payments.</li>
              <li>Plans may be billed monthly or annually and auto-renew unless canceled before renewal.</li>
              <li><strong>Refund Policy:</strong> Subscriptions are non-refundable except where required by law.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">3. User Responsibilities</h2>
            <ul className="space-y-2 text-foreground">
              <li>Provide accurate and truthful information for expenses, receipts, and accounts.</li>
              <li>Comply with all applicable laws.</li>
              <li>Do not engage in prohibited uses including fraudulent claims, hacking, scraping data, or impersonation.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">4. Data & Privacy</h2>
            <p className="text-foreground leading-relaxed">
              Use of our Services is also subject to our <a href="/privacy-policy" className="text-primary hover:text-primary/80 underline">Privacy Policy</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">5. Limitation of Liability</h2>
            <p className="text-foreground leading-relaxed">
              Services are provided "as is." CountedCare Inc. is not liable for errors in data entry, tax filings, or financial decisions. We disclaim all warranties to the fullest extent permitted by law.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">6. Governing Law & Dispute Resolution</h2>
            <p className="text-foreground leading-relaxed">
              These Terms are governed by California law. Any disputes will be resolved by binding arbitration in Los Angeles County, California. You waive the right to participate in class actions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">7. Modifications</h2>
            <p className="text-foreground leading-relaxed">
              We may update these Terms. Continued use after updates means you accept the new Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-foreground mb-4">8. Contact Us</h2>
            <address className="text-foreground not-italic leading-relaxed">
              CountedCare Inc.<br />
              1301 N Broadway STE 32274<br />
              Los Angeles, CA 90012<br />
              Email: <a href="mailto:info@countedcare.com" className="text-primary hover:text-primary/80 underline">info@countedcare.com</a>
            </address>
          </section>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;